import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getRepresentativeDetailsAsync } from '../../../store/slices/kyb/getRepresentativeDetailsSlice';

const SHOW_ON_ROUTES = ['/app/get-started', '/app/dashboard'];

export default function useRepresentativePrompt() {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const { status, value } = useAppSelector(
    (state) => state.getRepresentativeDetails,
  );
  const { value: authValue } = useAppSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getRepresentativeDetailsAsync());
  }, [dispatch]);

  const showBanner =
    status === 'success' &&
    Boolean(value?.data?.id) &&
    !value?.data?.isApproved &&
    value?.data?.userId !== authValue?.data?.user?.id &&
    SHOW_ON_ROUTES.some((route) => location.pathname.includes(route));

  return { showBanner };
}
